<template>
<div id="container" class="sub-container2">
    <div class="container_inner">
        <!--sc03_sub//start-->
        <div class="sc03 high">
            <div class="sc03_sub_area">
                <!-- sub -->
                <div class="data-top-menu scroll_x">
            		<!-- <a href="javascript: void(0);" :class="[dpTab == '' ? 'tm-btn tm-active' : 'tm-btn']"
                        @click.prevent="selectDetailTab('')">전체</a> -->
            		<a href="javascript: void(0);" :class="[dpTab == category.commonCode ? 'tm-btn tm-active' : 'tm-btn']"
                        v-for="category in indicatorCateList"
                        @click.prevent="selectDetailTab(category.commonCode)">
                        {{category.localeTitle}}
                    </a>
                </div>

                <div class="sc04dd_02 swiper-container detail-top-swiper-container">
                    <div class="sc04dd_02_area pd0 swiper-wrapper">
                        <span v-for="list in dispMap" class="swiper-slide">
                            <IndicatorBox
                                v-for="indicator in list"
                                :key="indicator.idxSqno"
                                :box-info="indicator"
                                :area-no="indicator.idxCateCd"
                                :box-clazz="boxClzz"
                                :indicator-data-map="indiDataMap"
                                :indicator-data-kd-hdng-map="indiHdngMap"/>
                        </span>
                    </div>

                    <div class="btn_pre swiper-button-prev"><a href="javascript: void(0);"></a></div>
                    <div class="btn_nxt swiper-button-next"><a href="javascript: void(0);"></a></div>
                </div>

                <div class="data_population2" v-for=" chart in chartList" :key="chart.mngChartSqno">
                    <h4 style="width:80%;">{{chart.mngChartNm}}</h4>
                    <div class="grph_area mt-10 ">
                        <Chart :chartid="chart.mngChartSqno"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Swiper from '@/assets/js/swiperjs/swiper-bundle.js';
import gripUtil from "@/libs/grip.util";
import {$_WC, $_TYPE} from '@/confs/common.const.js';
import Chart from '@/libs/grip.chart.v2.vue';
import IndicatorBox from '@/views/indicator/IndicatorBox.vue';
import {mapGetters} from "vuex";


export default {
    components: {
        Chart,
        IndicatorBox,
    },
    data() {
        return {
            dpTab: '',
            boxClzz: 'sc04dd_02_box',
            swiper: undefined,
            indiDataMap:{},
            indiHdngMap:{},
        }
    },
    created() {
        if(typeof this.selectedIndicatorCate !== $_TYPE.UNDEF) {
            this.selectDetailTab(this.selectedIndicatorCate);
        }
    },
    computed:{
        ...mapGetters({
            indicatorIdxList : 'getIndicatorIdxList',
            indicatorDataKdMap : 'getIndicatorDataKdMap',
            indicatorDataMap : 'getIndicatorDataMap',
            indicatorDataKdHdngMap : 'getIndicatorDataKdHdngMap',

            selectedIndicatorCate : 'getSelectedIndicatorCate',
            indicatorCateList : 'getIndicatorCateList',

            indicatorIdxCateMap : 'getIndicatorIdxCateMap',
            selectedIndicator: 'getSelectedIndicator',

            selectedIndicatorList : 'getSelectedIndicatorList',

            clazzMap: 'getClazzMap',
            selectedIndicatorDataMap: 'getSelectedIndicatorDataMap',
            selectedIndicatorDataKdHdngMap: 'getSelectedIndicatorDataKdHdngMap',
            selectedIndicatorMap: 'getSelectedIndicatorMap',
        }),
        dispList() {
            let tab = this.dpTab;
            let selectedIdxMap = this.selectedIndicatorMap[tab];
            let list = [];
            if(typeof selectedIdxMap !== $_TYPE.UNDEF) {
                list = selectedIdxMap.idxList;
                this.indiDataMap = selectedIdxMap.dataMap;
                this.indiHdngMap = selectedIdxMap.hdngMap;
            } else {
                list = this.selectedIndicatorList;
                this.indiDataMap = this.selectedIndicatorDataMap;
                this.indiHdngMap = this.selectedIndicatorDataKdHdngMap;
            }
            // if(tab == '') {
            //     list = this.indicatorIdxList;
            // } else {
            //     list = selectedIdxMap.idxList;
            //     this.indiDataMap = selectedIdxMap.dataMap;
            //     this.indiHdngMap = selectedIdxMap.hdngMap;
            // }
            return list;
        },
        dispMap() {
            let page = 0;
            let list = this.dispList;
            let map = {};
            if(typeof list !== $_TYPE.UNDEF && list.length > 0) {
                list.forEach((d,i) => {
                    if(typeof map[page] === $_TYPE.UNDEF) {
                        map[page] = [];
                    }
                    map[page].push(d);
                    if(i % 6 === 5) {
                        page ++;
                    }
                });
            }
            return map;
        },
        chartList() {
            let indicator = this.selectedIndicator;
            let charts = [];
            if(typeof indicator !== $_TYPE.UNDEF) {
                charts = indicator.idxCharts;
            }
            return charts;
        },
    },
    watch: {
        dispMap: {
            immediate: false,
            handler(newVal, oldVal) {
                this.$nextTick(() => {
                    this.setSwiper();
                })
            }
        },
    },
    methods:{
        selectDetailTab(tab) {
            this.dpTab = tab;
            this.$store.dispatch('FETCH_SELECTED_INDICATOR_IDX_LIST', 'openYn=1&searchCondition=idxCateCdStr&searchKeyword=' + tab);
        },
        setSwiper(){
            if(typeof this.swiper !== $_TYPE.UNDEF) {
                this.swiper.destroy();
                this.swiper = $_TYPE.UNDEF;
            }
            this.swiper = new Swiper('.detail-top-swiper-container', {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView : 1,
                // loop: true,
                // effect : 'coverflow',
                pagination: {
                    el: '.swiper-pagination'
                },
                mousewheel: true,
                keyboard: true,
                on: {
                    touchMove() {
                        _this.$eventBus.$emit("Swiper::touch-move");
                    },
                },
            });
        },
    },
}
</script>
